






















































































































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import * as axios from 'axios';
import { UIModel } from "@/UIModel";
import { indexOf } from "lodash";
import { FrontendAutodeskDmFolder } from "@/model/frontend/FrontendAutodeskDmFolder";
import { FrontendBIM360Project } from "@/model/frontend/FrontendBIM360Project";
import { RegisteredWebhook } from "@/model/RegisteredWebhook";
import { FrontendRegisteredWebhook } from "@/model/frontend/FrontendRegisteredWebhook";
import { ERegion } from "@/model/ERegion";

interface Drive {
        id: string,
        name: string,
        description: string,
        webUrl: string,
    }

interface SharepointSite {
        id: string,
        name: string,
        displayName: string,
        description: string,
        webUrl: string,
    }

@Component
export default class SPDocSync extends Vue {
    
    // Props
	@Prop({ required: true }) public model!: UIModel;
    
    // Data
    public files: File[] = [];
    public sites: SharepointSite[] = [];
    public registeredWebhooks: FrontendRegisteredWebhook[] = [];
    public selectedDrive: Drive | null = null;
    public selectedSite: SharepointSite | null = null;
    public selectedFile: File | null = null;
    public selectedFolder: FrontendAutodeskDmFolder | null = null;
    public drives: Drive[] = [];
    
    get folders() { return this.model.projectFolders.data; }

    // Methods
    async authenticate() {
        await this.model.msAuthLogin();      
    }

    async mounted() {
        if(this.model.msTenantId){
            this.sites = await this.model.getSharepointSites();
            if(this.model.selectedHub){
                this.registeredWebhooks = await this.model.getRegisteredWebhooks(this.model.selectedHub?.region as ERegion);
            }
        }
   }

    @Watch('selectedSite')
    async onSiteChanged(selectedSite: SharepointSite){
        if(selectedSite){
            this.drives = await this.model.getSharepointDrives(selectedSite);
        }
    }

    changeFolder(folder: FrontendAutodeskDmFolder){
        this.selectedFolder = folder;
    }
    
    changeSite(site: SharepointSite){
        this.selectedSite = site;
    }

    changeDrive(drive: Drive){
        this.selectedDrive = drive;
    }

    handleFileUpload() {
        const input = event!.target as HTMLInputElement;
        if (input.files) {
        this.files = Array.from(input.files);
        this.selectedFile = this.files[0];

        console.log("Files uploaded:", this.files);
        }
    }

    formatFileSize(size: number): string {
        const kb = size / 1024;
        const mb = kb / 1024;
        return mb > 1 ? `${mb.toFixed(2)} MB` : `${kb.toFixed(2)} KB`;
    }

    uploadToSharepoint() {
        if(this.selectedFile && this.selectedDrive){
            this.model.uploadFileToSPDrive(this.selectedFile, this.selectedDrive!.id);
            console.log("Uploaded");
        }
    }

    public async chooseProject(project: FrontendBIM360Project): Promise<void> {
       		this.model.selectProject(project);
    	}

    async registerWebhook() {
        console.log("Registering Webhook");
        if(this.model.selectedHub && this.model.selectedProject && this.selectedSite && this.selectedFolder && this.selectedDrive){
        await this.model.registerWebhook(
            this.model.selectedHub.region as ERegion,
            this.selectedFolder.id,
            this.model.selectedHub.name,
            this.model.selectedProject.name, 
            this.selectedSite.displayName,
            this.selectedDrive.name,
            // this.selectedFolder.attributes.displayName,
            this.selectedSite.id,
            this.selectedDrive.id,
        );
        this.registeredWebhooks = await this.model.getRegisteredWebhooks(this.model.selectedHub?.region as ERegion);
        }
    }

    async deleteWebhook(hookId: string){
        console.log("Deleting webhook");
        await this.model.deleteWebhook(hookId, this.model.selectedHub?.region as ERegion);
        this.registeredWebhooks = await this.model.getRegisteredWebhooks(this.model.selectedHub?.region as ERegion);
    }
    
    public get firstFile(): string {
        return this.files[0]?.name || '';
    }

    deleteDropFile(index: number) : void {
        this.files.splice(index, 1);
    }
    
}

